import { z } from 'zod';
/**
 * Schemas for the in-session "rules lookup" assistant. The GM speaks (or types) a question;
 * the server matches it against the cached D&D 5e SRD rules corpus (rule-sections + conditions)
 * and returns ranked hits whose full text can then be fetched for display.
 */
export const ruleEntryTypeSchema = z.enum(['rule-sections', 'conditions']);
export const ruleSearchHitSchema = z.object({
    type: ruleEntryTypeSchema,
    index: z.string(),
    /** Canonical SRD (English) name. */
    name: z.string(),
    /** Italian display name when known (conditions and common sections). */
    nameIt: z.string().optional(),
    score: z.number(),
    /** Short excerpt around the best match, for the result list. */
    snippet: z.string().optional(),
});
export const ruleLookupRequestSchema = z.object({
    query: z.string().min(1).max(2000),
    limit: z.number().int().positive().max(20).optional(),
});
export const ruleLookupResponseSchema = z.object({
    query: z.string(),
    results: z.array(ruleSearchHitSchema),
});
export const ruleEntrySchema = z.object({
    type: ruleEntryTypeSchema,
    index: z.string(),
    name: z.string(),
    nameIt: z.string().optional(),
    /** Rule body as Markdown (SRD text, English). */
    markdown: z.string(),
});
//# sourceMappingURL=rules.js.map